export default {
  "site.name": "USFansSheet",
  "site.tagline": "Przeglądaj, porównuj i porządkuj arkusz USFans Spreadsheet",
  "seo.homeTitle": "USFans Spreadsheet – Przeglądaj, porównuj i porządkuj zasoby",
  "seo.homeDesc": "USFansSheet to przejrzyste centrum informacji o USFans Spreadsheet. Przeglądaj kategorie, czytaj oryginalne poradniki i porównania, a potem rób zakupy na głównej stronie.",
  "seo.guideTitle": "USFans Spreadsheet – Kompletny przewodnik",
  "seo.guideDesc": "Dowiedz się, czym jest USFans Spreadsheet, jak go używać i na co zwracać uwagę w oryginalnym, szczegółowym przewodniku z porównaniami i FAQ.",

  "nav.home": "Strona główna",
  "nav.guide": "Poradnik zakupów",
  "nav.categories": "Kategorie",
  "nav.faq": "FAQ",
  "nav.buy": "Kup teraz",
  "nav.visitMain": "Odwiedź główną stronę",

  "hero.eyebrow": "Centrum zasobów USFans Spreadsheet",
  "hero.title": "Przeglądaj, porównuj i porządkuj USFans Spreadsheet",
  "hero.subtitle": "USFansSheet to przejrzyste, pomocne centrum zbudowane wokół USFans Spreadsheet. Przeglądaj uporządkowane kategorie, czytaj praktyczne przewodniki i porównuj zasoby — a następnie przejdź na główną stronę, aby zrobić zakupy w jednym miejscu.",
  "hero.trust": "Niezależne źródło · Regularnie aktualizowane · Nacisk na prywatność i bezpieczeństwo",
  "hero.cta.main": "USFans Spreadsheet",
  "hero.cta.buy": "Kup teraz",
  "hero.cta.guide": "Przeczytaj przewodnik",

  "what.title": "Czym jest USFans Spreadsheet?",
  "what.text1": "USFans Spreadsheet to uporządkowany sposób organizowania i przeglądania informacji o twórcach i produktach w jednym, przeszukiwalnym widoku. Zamiast przeskakiwać między rozproszonymi stronami, zasób w formie arkusza łączy wszystko razem, dzięki czemu łatwiej jest go przeglądać, porównywać i rozumieć.",
  "what.text2": "USFansSheet powstał wokół tego tematu. Publikujemy oryginalne przewodniki, porównania i FAQ, które pomagają zrozumieć dostępne zasoby, a następnie kierujemy Cię na główną stronę, gdzie możesz przeglądać pełny katalog.",
  "what.cta": "Poznaj przewodnik po arkuszu",

  "categories.title": "Przeglądaj według kategorii",
  "categories.subtitle": "Przejdź od razu do kolekcji, której szukasz, na głównej stronie.",
  "drop.label": "Wybierz kategorię",
  "drop.hint": "Wybierz kategorię, aby kontynuować",

  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy / Swetry",
  "cat.tshirts": "T-shirty",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie / Spodenki",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna / Majtki",
  "cat.jersey": "Koszulka sportowa",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne rzeczy",

  "features.title": "Dlaczego USFansSheet",
  "features.1.title": "Uporządkowane",
  "features.1.text": "Wszystko jest pogrupowane w przejrzyste kategorie, dzięki czemu znajdziesz to, czego potrzebujesz, bez przekopywania rozproszonych stron.",
  "features.2.title": "Łatwe porównywanie",
  "features.2.text": "Korzystaj z uporządkowanych przewodników i prostych tabel porównawczych, aby rozważyć opcje przed kliknięciem.",
  "features.3.title": "Bezpieczne i pomocne",
  "features.3.text": "Dbamy o jasność i uczciwość, skupiając się na pomaganiu Ci w podejmowaniu lepszych decyzji — bez bałaganu i sztuczek.",

  "compare.title": "USFans Spreadsheet kontra tradycyjne wyszukiwanie",
  "compare.colFeature": "Funkcja",
  "compare.colA": "Arkusz",
  "compare.colB": "Tradycyjne wyszukiwanie",
  "compare.row1.f": "Uporządkowane informacje",
  "compare.row1.a": "Tak",
  "compare.row1.b": "Ograniczone",
  "compare.row2.f": "Łatwe porównywanie",
  "compare.row2.a": "Tak",
  "compare.row2.b": "Ograniczone",
  "compare.row3.f": "Organizacja",
  "compare.row3.a": "Wysoka",
  "compare.row3.b": "Niska",
  "compare.row4.f": "Filtrowanie",
  "compare.row4.a": "Możliwe",
  "compare.row4.b": "Ograniczone",
  "compare.row5.f": "Przyjazne dla początkujących",
  "compare.row5.a": "Tak",
  "compare.row5.b": "Średnio",
  "compare.row6.f": "Zasoby dla konkretnego tematu",
  "compare.row6.a": "Tak",
  "compare.row6.b": "Mieszane",

  "articlePromo.title": "Przeczytaj pełny przewodnik po USFans Spreadsheet",
  "articlePromo.text": "Nowy w temacie? Nasz szczegółowy przewodnik wyjaśnia, czym jest USFans Spreadsheet, jak go używać i na co zwracać uwagę — wszystko w jednym oryginalnym artykule.",
  "articlePromo.cta": "Otwórz przewodnik",

  "faq.title": "Często zadawane pytania",
  "faq.q1": "Czym jest USFans Spreadsheet?",
  "faq.a1": "To uporządkowany, przeszukiwalny sposób organizowania informacji o twórcach i produktach w jednym widoku, ułatwiający przeglądanie, porównywanie i rozumienie.",
  "faq.q2": "Czy USFansSheet to oficjalna strona USFans?",
  "faq.a2": "Nie. USFansSheet to niezależne źródło informacyjne. Pełny katalog znajdziesz na głównej stronie.",
  "faq.q3": "Gdzie mogę przeglądać produkty?",
  "faq.a3": "Skorzystaj z menu kategorii powyżej lub odwiedź główną stronę bezpośrednio. Każda kategoria prowadzi do odpowiedniej sekcji.",
  "faq.q4": "Czy sprzedajecie produkty na tej stronie?",
  "faq.a4": "Nie. Ta strona udostępnia przewodniki i zasoby. Wszystkie produkty są dostępne na głównej stronie.",
  "faq.q5": "Czy moje dane są bezpieczne?",
  "faq.a5": "Nie zbieramy danych osobowych ani danych płatniczych. Zawsze weryfikuj ważne informacje i unikaj podejrzanych linków.",
  "faq.q6": "Jak często aktualizowana jest treść?",
  "faq.a6": "Regularnie przeglądamy i odświeżamy nasze przewodniki, ale ceny, stany i wysyłka mogą się zmieniać — zawsze sprawdzaj aktualne szczegóły na głównej stronie.",

  "article.h1": "USFans Spreadsheet: Kompletny przewodnik",
  "article.short": "USFans Spreadsheet to uporządkowany, przeszukiwalny zasób, który organizuje informacje o twórcach i produktach w jednym miejscu, ułatwiając przeglądanie, porównywanie i rozumienie. Ten przewodnik wyjaśnia, jak to działa i na co zwracać uwagę.",
  "article.intro": "Jeśli natknąłeś się na pojęcie „USFans Spreadsheet” i chcesz zrozumieć, co ono naprawdę oznacza i jak z niego korzystać, jesteś we właściwym miejscu. Ten przewodnik wyjaśnia ten pomysł prostym językiem, pokazuje, na co zwracać uwagę, i pomaga w pełni wykorzystać te zasoby. Pokazujemy też, gdzie znaleźć pełny katalog na głównej stronie.",
  "article.toc.title": "Spis treści",
  "article.toc.1": "Czym jest USFans Spreadsheet?",
  "article.toc.2": "Dlaczego ludzie używają arkusza",
  "article.toc.3": "Jak korzystać z USFans Spreadsheet",
  "article.toc.4": "Arkusz kontra tradycyjne wyszukiwanie",
  "article.toc.5": "Na co zwracać uwagę w dobrym zasobie",
  "article.toc.6": "Często zadawane pytania",
  "article.s1.title": "Czym jest USFans Spreadsheet?",
  "article.s1.p": "USFans Spreadsheet to uporządkowany sposób organizowania informacji o twórcach i produktach w jednym, przeszukiwalnym widoku. Pomyśl o nim jak o przejrzystej tabeli, która grupuje powiązane elementy — nazwy, kategorie, linki i szczegóły — dzięki czemu możesz ogarnąć wszystko jednym rzutem oka zamiast klikać przez wiele oddzielnych stron. Cel jest prosty: ułatwić znajdowanie, porównywanie i rozumienie informacji.",
  "article.s2.title": "Dlaczego ludzie używają arkusza",
  "article.s2.p": "Arkusze są popularne z jednego prostego powodu: zmniejszają wysiłek związany z wyszukiwaniem. Gdy informacje są rozproszone po wielu stronach, ich znajdowanie i porównywanie zajmuje czas. Dobrze zorganizowany arkusz łączy powiązane elementy w jednym miejscu, dzięki czemu widzisz wzorce, dostrzegasz różnice i szybciej podejmujesz decyzje. Dla tematu takiego jak USFans, z wieloma kategoriami i zasobami, taka struktura jest szczególnie przydatna.",
  "article.s3.title": "Jak korzystać z USFans Spreadsheet",
  "article.s3.intro": "Oto prosty sposób na rozpoczęcie, krok po kroku:",
  "article.s3.1": "Zacznij od kategorii — większość arkuszy grupuje elementy według kategorii, takich jak Buty, Bluzy / Swetry, T-shirty, Kurtki i inne. Zacznij od grupy odpowiadającej temu, czego szukasz.",
  "article.s3.2": "Przeglądaj i porównuj — patrz na wiersze i kolumny, aby porównać nazwy, szczegóły i linki obok siebie.",
  "article.s3.3": "Podążaj za źródłem — dobry arkusz odsyła do oryginalnego źródła. Używaj tych linków, aby zweryfikować szczegóły i zobaczyć pełny obraz.",
  "article.s3.4": "Weryfikuj zanim zadziałasz — ceny, stany i wysyłka mogą się zmieniać. Zawsze sprawdzaj aktualne informacje na głównej stronie.",
  "article.s4.title": "Arkusz kontra tradycyjne wyszukiwanie",
  "article.s5.title": "Na co zwracać uwagę w dobrym zasobie",
  "article.s5.p": "Nie wszystkie arkusze są takie same. Dobry zasób jest przejrzyście zorganizowany, łatwy do czytania i odsyła do wiarygodnego źródła. Powinien być regularnie aktualizowany i nigdy nie wywierać na Tobie presji. Przede wszystkim powinien szanować Twoją prywatność i nigdy nie prosić o hasła, dane płatnicze ani inne wrażliwe informacje. Jeśli zasób o to prosi, potraktuj to jako czerwoną flagę i odejdź.",
  "article.related": "Szukasz czegoś więcej? Wróć na stronę główną, aby przeglądać wszystkie kategorie i zasoby, lub przeczytaj powiązane przewodniki na naszej głównej stronie.",
  "article.back": "Wróć na stronę główną",
  "article.cta": "Przeglądaj pełny katalog na głównej stronie",
  "article.meta.author": "Zespół redakcyjny USFansSheet",
  "article.meta.date": "Regularnie aktualizowane",

  "footer.desc": "Niezależne, pomocne źródło zbudowane wokół USFans Spreadsheet. Przeglądaj kategorie, czytaj przewodniki i przejdź na główną stronę, aby zrobić zakupy w jednym miejscu.",
  "footer.resources": "Zasoby",
  "footer.resources.guide": "Przewodnik po arkuszu",
  "footer.resources.categories": "Kategorie",
  "footer.resources.faq": "FAQ",
  "footer.main": "Główna strona",
  "footer.main.desc": "Odwiedź główną stronę, aby przeglądać pełny katalog.",
  "footer.disclaimer": "USFansSheet to niezależne źródło informacyjne i nie jest powiązane z główną stroną. Wszystkie produkty i zakupy są obsługiwane na głównej stronie.",
  "footer.copyright": "© 2026 USFansSheet. Wszelkie prawa zastrzeżone.",

  "resources.title": "Poznaj zasoby USFans",
  "resources.subtitle": "Pomocne przewodniki i materiały, które ułatwią przeglądanie, porównywanie i pewne zakupy.",
  "res.learnMore": "Dowiedz się więcej",
  "res.spreadsheet.title": "USFans Spreadsheet",
  "res.spreadsheet.text": "Uporządkowane przewodniki do odkrywania i porządkowania zasobów twórców.",
  "res.directory.title": "Katalog twórców",
  "res.directory.text": "Dowiedz się, jak działają katalogi i listy twórców.",
  "res.reviews.title": "Recenzje",
  "res.reviews.text": "Na co zwracać uwagę przed zakupami, wyjaśnione rzetelnie.",
  "res.comparisons.title": "Porównania",
  "res.comparisons.text": "Porównuj zasoby obok siebie, aby szybciej decydować.",
  "res.safety.title": "Centrum bezpieczeństwa",
  "res.safety.text": "Wskazówki dotyczące prywatności, bezpieczeństwa konta i odpowiedzialnego użytkowania.",
  "res.guides.title": "Przewodniki",
  "res.guides.text": "Praktyczne poradniki dla początkujących i zaawansowanych.",

  "articles.title": "Przewodniki tematyczne USFans",
  "articles.subtitle": "Dziesięć oryginalnych przewodników na tematy, których ludzie szukają najczęściej.",
  "articles.read": "Czytaj przewodnik",
  "articles.related": "Powiązane przewodniki",

  "article.notFound": "Nie znaleziono artykułu",
};